import React, { ReactNode } from 'react';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import Keycloak, { KeycloakProfile, KeycloakInitOptions, KeycloakTokenParsed } from 'keycloak-js';

interface MockKeycloakProviderProps {
    children: ReactNode;
}

interface CustomKeycloakTokenParsed extends KeycloakTokenParsed {
    resource_access?: {
        [key: string]: {
            roles: string[];
        };
    };
}

const token = "A random string that is non zero length";
const userProfile: KeycloakProfile = {
    username: "test",
    email: "test@example.com",
    firstName: "Test",
    lastName: "User",
};
const realmAccess = { roles: ["user", "admin"] };

const mockKeycloakInstance: Keycloak = {
    authenticated: true,
    hasRealmRole(ignored: string) {
        return true;
    },
    hasResourceRole(ignored: string) {
        return true;
    },
    init(initOptions: KeycloakInitOptions) {
        return new Promise(function (resolve) { resolve(true); });
    },
    idToken: token,
    profile: userProfile,
    realm: "TestRealm",
    realmAccess,
    refreshToken: token,
    token,
    tokenParsed: {
        resource_access: {
            'glow-application': {
                roles: ['user', 'GLOW_ADMIN']
            }
        }
    } as CustomKeycloakTokenParsed,
} as Keycloak;

const MockKeycloakProvider: React.FC<MockKeycloakProviderProps> = ({ children }) => {
    return (
        <ReactKeycloakProvider authClient={mockKeycloakInstance}>
            {children}
        </ReactKeycloakProvider>
    );
};

export default MockKeycloakProvider;
